<div id="process-container">
  <h1 class="my-4" *ngIf="productSelected.code != 232 ">{{ productSelected.code === '951' ? copyService.copies.step_process_title_living : copyService.copies.step_process_title}}</h1>
  <h1 class="my-4" *ngIf="productSelected.code == 232 ">{{ copyService.copies.step_process_title_multi}}</h1>
  <h4 *ngIf="productSelected.code != 232 ">{{ productSelected.code === '951' ? copyService.copies.step_process_subtitle_living : copyService.copies.step_process_subtitle }}</h4>
  <h4 *ngIf="productSelected.code == 232 ">{{ copyService.copies.step_process_subtitle_living }}</h4>
  <div id="steps">
    <ul>
      <li *ngFor="let step of steps">
        <img src="assets/images/{{step.img}}" alt="{{step.img}}">
        <div class="step-label">
          <strong>{{step.title}}</strong>
          <p>{{step.description}}</p>
        </div>
      </li>
    </ul>
  </div>
  <app-controls id="button-process" [back]="back" [hasPrevious]="true" [nextLabel]="copyService.copies.product_selection_go_step_process" (next)="next()"></app-controls>
</div>